// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor-toolbar .bx--btn.bx--btn--icon-only.bx--tooltip__trigger+.bx--assistive-text,.editor-toolbar .bx--btn.bx--btn--icon-only.bx--tooltip__trigger .bx--assistive-text,.editor-toolbar .bx--btn.bx--btn--icon-only.bx--tooltip__trigger:after{transform:translate(-75%,100%);min-width:24px;max-width:208px;padding:3px 16px;font-size:14px}", ""]);
// Exports
module.exports = exports;
